import { motion } from "framer-motion";
import { Calendar, Feather } from "lucide-react";
import ChapterMarker from "@/components/ChapterMarker";
import NewsletterSignup from "@/components/NewsletterSignup";

const EASE = [0.16, 1, 0.3, 1];

const UPCOMING_COVER =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_stopa-books/artifacts/e7ede439c53e07c6_GloryInTheWaitingCOVER_F.png";

export default function ComingSoon() {
  return (
    <section
      id="coming-soon"
      data-testid="coming-soon-section"
      className="relative overflow-hidden bg-abbey-dark px-6 py-24 md:px-12 md:py-32 lg:px-24 lg:py-40"
    >
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[70vw] w-[70vw] -translate-x-1/2 -translate-y-1/2 animate-candle-flicker glow-orb md:h-[45vw] md:w-[45vw]" />

      <div className="relative mx-auto max-w-7xl">
        <ChapterMarker number="02" eyebrow="Chapter Two — The Next Book" title="Coming Soon" dark />

        <div className="flex flex-col items-center gap-16 lg:flex-row lg:gap-24">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1, ease: EASE }}
            className="book-scene shrink-0"
          >
            <div
              className="book-cover relative aspect-[2/3] w-56 overflow-hidden bg-abbey-ink md:w-72"
              data-testid="coming-soon-cover"
            >
              <img
                src={UPCOMING_COVER}
                alt="Glory in the Waiting: An Advent Stories Collection — book cover"
                loading="lazy"
                className="h-full w-full object-cover"
                data-testid="coming-soon-cover-image"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1, ease: EASE, delay: 0.15 }}
            className="max-w-xl"
          >
            <div className="flex items-center gap-3">
              <Feather className="h-4 w-4 text-abbey-gold" strokeWidth={1.5} />
              <p className="font-cinzel text-[11px] tracking-[0.35em] text-abbey-gold">
                THE NEXT BOOK — ADVENT 2026
              </p>
            </div>
            <h3 className="mt-6 font-cormorant text-3xl font-medium leading-tight text-abbey-cream sm:text-4xl lg:text-5xl">
              Glory in the <span className="italic text-abbey-gold">Waiting.</span>
            </h3>
            <p className="mt-2 font-cormorant text-xl italic text-abbey-cream/60">
              An Advent Stories Collection
            </p>
            <p className="mt-6 text-sm leading-relaxed text-abbey-cream/70 md:text-base">
              A new collection of short stories celebrating the season of
              Advent — tales that resonate with its four great themes of hope,
              peace, joy, and love, from the first blue candle to Christmas
              Eve.
            </p>
            <div
              className="mt-8 inline-flex items-center gap-3 border border-[rgba(212,175,55,0.4)] px-5 py-3"
              data-testid="coming-soon-release-date"
            >
              <Calendar className="h-4 w-4 text-abbey-gold" strokeWidth={1.5} />
              <span className="font-cinzel text-[11px] tracking-[0.25em] text-abbey-gold">
                AVAILABLE NOVEMBER 21, 2026 ON AMAZON
              </span>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-abbey-cream/70 md:text-base">
              Join the list below and you'll be the first to know the moment it
              arrives.
            </p>
            <div className="mt-10">
              <NewsletterSignup idPrefix="coming-soon" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
